import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import TheRiad from '@/pages/TheRiad';
import Rooms from '@/pages/Rooms';
import Spaces from '@/pages/Spaces';
import Services from '@/pages/Services';
import Location from '@/pages/Location';
import Availability from '@/pages/Availability';
import { Toaster } from '@/components/ui/sonner';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/le-riad" element={<TheRiad />} />
              <Route path="/chambres" element={<Rooms />} />
              <Route path="/espaces" element={<Spaces />} />
              <Route path="/services" element={<Services />} />
              <Route path="/localisation" element={<Location />} />
              <Route path="/disponibilites" element={<Availability />} />
            </Routes>
          </Layout>
          <Toaster position="top-center" />
        </BrowserRouter>
      </div>
    </I18nextProvider>
  );
}

export default App;
